export const NOVELTY_VALIDATE_MESSAGE = "プレゼントされるノベルティに変更がありました。確認してください。"
